/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Order_Ready_To_DeliverInputs */

const vi_status_order_ready_to_deliver = /** @type {(inputs: Status_Order_Ready_To_DeliverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sẵn sàng giao`)
};

/**

* @param {Status_Order_Ready_To_DeliverInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const status_order_ready_to_deliver = /** @type {((inputs?: Status_Order_Ready_To_DeliverInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Order_Ready_To_DeliverInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_status_order_ready_to_deliver(inputs)
});